module.exports = __webpack_public_path__ + "e65bfae8a8b1c32b9a7a41fce2f0a95c.MP3";